import { Card, CardContent, CardFooter } from '@/components/ui/card';

import { cn } from '@/lib/utils';

type Variant = 'hint' | 'info' | 'error' | 'success';

const variantClasses: Record<Variant, string> = {
	hint: 'bg-amber-50 text-amber-800',
	info: 'bg-blue-50 text-blue-800',
	error: 'bg-red-50 text-red-800',
	success: 'bg-green-50 text-green-800',
};

const variantTitleClasses: Record<Variant, string> = {
	hint: 'text-amber-800',
	info: 'text-blue-800',
	error: 'text-red-800',
	success: 'text-green-800',
};

const variantDescriptionClasses: Record<Variant, string> = {
	hint: 'text-amber-700',
	info: 'text-blue-700',
	error: 'text-red-700',
	success: 'text-green-700',
};

export const InformationBox = ({
	className,
	titleClassName,
	descriptionClassName,
	descriptionList = [],
	title,
	description,
	variant = 'info',
	footer,
	contentProps,
}: {
	className?: string;
	titleClassName?: string;
	descriptionClassName?: string;
	title?: string;
	description?: string;
	descriptionList?: string[];
	variant: Variant;
	footer?: React.ReactNode;
	contentProps?: React.HTMLAttributes<HTMLDivElement>;
}) => {
	return (
		<Card className={cn('w-full rounded-md text-xs shadow-none', variantClasses[variant])}>
			<CardContent
				className="p-0"
				{...(contentProps || {})}
			>
				<div className={cn(className, 'flex justify-between gap-4 px-3 py-4')}>
					<div>
						{title && (
							<h3
								className={cn(
									'mb-1 text-sm font-semibold',
									variantTitleClasses[variant],
									titleClassName
								)}
							>
								{title}
							</h3>
						)}
						{descriptionList.length > 0 ? (
							<ul className={cn('mt-1 flex flex-col gap-1.5 text-[13px]', descriptionClassName)}>
								{descriptionList.map((item, index) => (
									<li
										key={index}
										className="ml-4 list-disc"
									>
										{item}
									</li>
								))}
							</ul>
						) : description ? (
							<p
								className={cn(
									'mt-1 text-[13px]',
									variantDescriptionClasses[variant],
									descriptionClassName
								)}
							>
								{description}
							</p>
						) : null}
					</div>
				</div>

				{footer && <CardFooter className="p-3 pt-0">{footer}</CardFooter>}
			</CardContent>
		</Card>
	);
};
